export enum EmployeeRole {
  Owner = 'owner',
  Admin = 'admin',
  Member = 'member',
}
